import { sendToTerminal } from '../../terminalLogger';
import { LogCategory } from '../../../config/logging';

/**
 * Centralized logging helpers for pipelines
 * Reduces verbosity while maintaining critical information
 */

/**
 * Logs a pipeline stage (start, finish, or critical step)
 * Only logs critical stages - intermediate SEND/RESULT logs are removed
 * @param pipelineId Unique pipeline identifier
 * @param stage Stage name (e.g., 'START', 'FINISH', 'ORGANIZAR', 'DISTRIBUIR')
 * @param data Optional data to include in log
 */
export function logPipelineStage(pipelineId: string, stage: string, data?: any): void {
  const stageUpper = stage.toUpperCase();
  
  // Only log critical stages
  if (stageUpper === 'START') {
    sendToTerminal(`📦 [PIPELINE] START`, {
      pipelineId,
      ...data
    }, LogCategory.BUSINESS);
  } else if (stageUpper === 'FINISH' || stageUpper === 'FINALIZADO') {
    sendToTerminal(`✅ [PIPELINE] FINALIZADO`, {
      pipelineId,
      ...data
    }, LogCategory.BUSINESS);
  } else {
    // For other stages, only log if they're critical (errors are handled separately)
    sendToTerminal(`🔄 [PIPELINE] ${stage}`, {
      pipelineId,
      ...data
    }, LogCategory.BUSINESS);
  }
}

/**
 * Logs a pipeline error
 * @param pipelineId Unique pipeline identifier
 * @param stage Stage where error occurred
 * @param error Error object or message
 */
export function logPipelineError(pipelineId: string, stage: string, error: any): void {
  const errorMsg = error?.message || error?.error || (typeof error === 'string' ? error : 'Erro desconhecido');
  
  sendToTerminal(`❌ [PIPELINE] Erro em ${stage}`, {
    pipelineId,
    stage,
    error: errorMsg,
    ...(error && typeof error === 'object' && !error.message && !error.error ? error : {}),
    code: error?.code
  }, LogCategory.ERROR);
}

